import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { AltraParte } from '../../../models/altraparte';
import { SezioneAltreParti } from '../../../models/sezioni/sezione-altre-parti';
import { AltrePartiUpdateAssociativaComponent } from './altre-parti-update-associativa.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [altreparti-mod-associativa-update]',
  templateUrl: 'altreparti-mod-associativa-update.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class AltrePartiModAssociativaUpdate {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<SezioneAltreParti> = new EventEmitter<SezioneAltreParti>();
  @ViewChild('formAssociativa') formAssociativa: AltrePartiUpdateAssociativaComponent;

  inizializza(urlUpdateAssociativa: string, altraParte: AltraParte, idSezione: string, urlSezioneControparti: string, idSezioneControparti: string) {

    this.formAssociativa.inizializza(urlUpdateAssociativa, altraParte, idSezione, urlSezioneControparti, idSezioneControparti);
    openModal('modalmodassociativa');
  }

  createForm() {
    this.formAssociativa.createForm();
  }

  manageModal(sezione: SezioneAltreParti) {
      closeModal('modalmodassociativa');
      this.onReturn.emit(sezione);
  }
}
